import React from 'react';
import styled from 'styled-components';
import Img from '../components/Img';

import img_title from '../assets/img/pc02-10.png';
import {breakPoint} from '../styles/var';

const ContentStyles = styled.div`
  background-color: var(--bg);
  position: relative;
  padding-bottom: 4rem;

  box-shadow: 0 1.8rem 1.5rem rgba(0,0,0, 0.3);
  z-index: 1;
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    > img {
      width: 100%;
      height: 100%;
    }
  }
  @media (min-width: ${breakPoint.min}) {
    margin-bottom: 4rem;
  }
`;

const WrapStyles = styled.div`
  max-width: ${breakPoint.lgMin};
  margin-right: auto;
  margin-left: auto;
  display: flex;
  gap: 2rem;
  align-items: flex-end;
  justify-content: center;
  padding: 3rem 2rem 3rem 5rem;
  > div {
    flex: 1 1 50%;
    max-width: 50%;
  }
  > picture {
    flex: 1 1 40%;
    max-width: 40%;
    margin-right: 0;
  }
  @media (min-width: ${breakPoint.lgMin}) {
    padding: 5rem 2rem 5rem 5rem;
    gap: 5rem;
    
  }
  @media (max-width: ${breakPoint.smMax}) {
    padding: 1.5rem 1rem 1.5rem 2rem;
    > div {
      flex: 1 1 60%;
      max-width: 60%;
    }
  }
`;

const IframeStyles = styled.div`
  background-color: var(--white);
  position: relative;
  width: 100%;
  box-shadow: 8rem -5rem 0 0 var(--secondary);
  &::before {
    content: '';
    display: block;
    width: 100%;
    padding-top: 63%;
  }
  > iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  @media (max-width: ${breakPoint.smMax}) {
    box-shadow: 3rem -2rem 0 0 var(--secondary);
  }
`;

const Section1 = (props) => {
  return (
    <ContentStyles {...props}>
      <WrapStyles>
        <Img src={img_title} alt="family style" wrapProps={{className: 'title'}}/>
        <IframeStyles>
          <iframe src="https://www.youtube.com/embed/-CeJPVspAl4" title="YouTube video player" frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen/>
        </IframeStyles>

      </WrapStyles>

    </ContentStyles>
  )
};

export default Section1;
